.flex {
  display: flex;
}

.justifyCenter {
  justify-content: center;
}

.justifyStart {
  justify-content: flex-start;
}

.justifyEnd {
  justify-content: flex-end;
}

.justifySpaceBetween {
  justify-content: space-between;
}

.alignStart {
  align-items: flex-start;
}

.alignEnd {
  align-items: flex-end;
}

.alignCenter {
  align-items: center;
}

.rowDirection {
  flex-direction: row;
}

.columnDirection {
  flex-direction: column;
}

.fullWidth {
  width: 100%;
}

.wrap {
  flex-wrap: wrap;
}